import configData from '../../config.json';
import { getAuthVersion, hasAnyAuthParams } from '../../utils/app/queryParams';
import httpClient from './httpClient';

function createAuthenticationContractError(response) {
  const error = new Error(
    'Authentication response did not contain an authorization header',
  );

  error.name = 'AuthenticationContractError';
  error.status = response.status;
  error.correlationId = response.correlationId || '';
  error.data = response.data;

  return error;
}

export async function authenticate(authParams = {}, options = {}) {
  if (!hasAnyAuthParams(authParams)) {
    const error = new Error(
      'A complete authentication parameter set is required',
    );
    error.name = 'InvalidAuthenticationParametersError';
    throw error;
  }

  const authVersion = getAuthVersion(authParams);
  const path = `/Authenticate/${authVersion}`;

  const query =
    authVersion === 'v1'
      ? {
          ekid: authParams.ekid,
          enpd: authParams.enpd,
          enfd: authParams.enfd,
          cmac: authParams.cmac,
          'subscription-key': configData.subscriptionkey,
        }
      : {
          rid: authParams.rid,
          p: authParams.p,
          c: authParams.c,
          m: authParams.m,
          original_url: authParams.originalUrl,
          'subscription-key': configData.subscriptionkey,
        };

  const response = await httpClient.get(path, {
    query,
    responseType: 'text',
    signal: options.signal,
  });

  const token = response.headers.get('authorization')?.trim() || '';

  if (!token) {
    throw createAuthenticationContractError(response);
  }

  return {
    token,
    status: response.status,
    correlationId: response.correlationId,
    data: response.data,
  };
}
